module.exports = __webpack_public_path__ + "assets/img/1.5ed2daea.png";